/* eslint-disable max-lines */
import { message as $message } from 'antd'
import {
    getUserMenuPermission,
    queryHidedMenuList,
    getUserMenus,
    queryUserMenuWhiteList,
} from '@/services/permissionMenu'
import { queryBindShopApi, queryShopInfoTotal, queryPlatformBanKeywords } from '@/services/myGoods'
import { queryAppShelvesGuideWhiteListUsingGET1 } from '@/services/goods'
import { getBigShopCoIdList } from '@/services/freshman'
import { getContractVersion } from '@/services/login'
import { history } from 'umi'
import { PLATFORM_INFO_LIST, filterShopTypeListByPlatformType } from '@/modules/globals/constants/platform/basics'
import { isZongHengApp, fullAppCode } from '@/utils/singleApp'
import { captureMessage } from '@/utils/track'
import { getStore } from '@/utils/dva'

import {
    FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_WXSTORE,
    FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_KDT,
    ERP_AFTERSALE_BIGSHOP_AUTO,
    ORDER_SIMULATION_CALC_NEW,
    AFTERSALE_EXPRESS_INTERCEPT_TPW_SUPPLY_DISTRIBUTION_WHITELIST,
    DISTRIBUTOR_AFTERSALE_ORDER_SUPPORTS_FILTER_RETURN_LOGISTICS_STATUS,
    COMMISSION_SUPPORT_GOODS_SKU,
    COMMISSION_EXTEND_REFUND_TYPE,
    NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST,
    PUSH_TO_SUPPLIER_AMOUNT_BY_AFTERSALE_TYPE_WHITELIST,
    AFTER_SALE_JD_AUTO_RETURN_REFUND_WHITE_LIST,
    DIS_DRP_SPLIT_REPUSH_RECALC_WHITELIST,
    DRP_FREE_HANDLING_FEE_WHITE_LIST,
    DRP_FREE_HANDLING_FEE_V2_WHITE_LIST,
    AFTERSALE_TWICE_EXCHANGE_ORDER_MULTI_PUSH,
    MULTI_LEVEL_DISTRIBUTION_REISSUE_NORMALIZE_AUTO_SYNC,
    MULTI_ADDRESS_UPGRADE_SWITCH_WHITELIST,
    SUP_GOODS_STRATEGY_FOR_RETURN_ADDRESS_WHITE_LIST,
    DRP_SEND_EXCHANGE_ALLOW_FUND_NEGATIVE,
    TIKTOK_PLATFORM_WHITE_LIST,
    AFTER_SALE_ADDRESS_MIDDLEMAN,
    DRP_SEND_UPLOAD_AFS_ADDRESS_PDD,
    AFTER_SALE_ORDER_BEAR_FREIGHT_SELECTION_WHITELIST,
    RULE_OPERATE_ERP_LABEL_WHITE_LIST,
    SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST,
    AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST,
    AFTERSALE_NEGOTIATION_ENABLE_WHITELIST,
    ORDER_FREIGHT_CALC_RULE_SHOW,
    AFTER_SALES_RETURN_ASYNC_WHITELIST,
    SEARCH_STOCK_BLOCK,
    DOU_YIN_SPU_MANAGE,
    EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST,
    CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST,
    DRP_RULE_MERGE,
    GOODS_RULE_OPERATE_V2,
    SHOW_CURRENT_ARREARS_COIDS,
    ORDER_EXCHANGE_GOODS_WHITE_LIST,
    GOODS_DRAFT_STATUS,
    PRINTER_CLOSE_WHITE_LIST,
    PRINTER_CLOSE_PROMT_WHITE_LIST,
    ORDER_DRP_ZPLAN_SETLC_REFREIGHT,
    ACCESS_PRE,
    DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE,
    GOODS_WECHAT_NOTIFY_COID,
    INSIDER_COID_LIST,
    ASYNC_AUDIT_ORDER_WHITE_LIST,
    HOT_GOODS_PRIVILEGE,
    MULTI_LEVEL_DIS_SETTLEMENT_WHITE_LIST,
    AFTER_SALE_IPC_OPEN_V2,
    AFTER_SALE_IPC_OPEN_MERGE,
    AS_SHIP_UPLOAD_RETURN_ADDRESS_WHITE_LIST,
    ORDER_GUIDE_WHITELIST_MASTER_SLAVE,
    PURCHASE_AMOUNT_SHARDING_WHITELIST,
    ORDER_ORIGINAL_SOID_WHITELIST,
    PENDING_ORDERS_BY_SUPPLIER_COUNT,
    CHANNEL_CUSTOMER_CENTER_DIY_DATE,
    PAY_REFUND_ONLINE_SUFFIX_WHITELIST,
    UNDERPRICED_ORDER_WHITELIST,
    GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST,
    SUPPLIER_AUTO_REFUND,
    DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST,
    AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST,
    FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST,
    BATCH_UPDATE_DIS_PRICE_WHITE_LIST,
    MIN_PURCHASE_COIDS,
    PUSH_ORDER_COMMERCIALIZE_WHITELIST,
    FORECAST_PLATFORM_WHITE_LIST,
    SHOP_ITEM_UPDATE_DELIVERY_TIME,
    DY_ALLOW_MODIFY_CATEGORY,
    TMALL_BACTH_SHELVES_USE_PRODUCT_WHITELIST,
    UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST,
    GOODS_RULE_OPERATE_SKU_REPLENISHMENT,
    DOUYIN_TIME_SALE_STOCK,
    PRINTER_INOUT_LIST_5000_WHITELIST,
    AUTONOMY_SYNC_PLATFORM_CATE_WHITE,
    FIND_DAREN_WHITELIST,
    DRP_EXPRESS_AGENCY_DELIVING_LIMIT_SYNC_STOCK,
    PARTNER_SPU_SHOP_LINK_WHITE_LIST,
    DRP_NOT_SYNC_ABNORMAL,
    TAO_GOODS_SHELVES_TAO_PLATFORM,
    CLEAR_PARTNER_SALE_MARK_WHITE_LIST,
    ORDER_TIMEOUT_COMPENSATION,
    PRINTER_MTSGYY_UPGRADE_WAYBILL_WHITELIST,
    DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST,
    ORDER_SPLIT_IGNORE_QUESTION,
    CAPTCHA_VALIDATE,
    AI_FILL_SPEC_VALUE_WHITE_LIST,
    DAREN_FIND_DAREN_KS_WHITE_LIST,
    DAREN_FIND_DAREN_SPH_WHITE_LIST,
} from '@/modules/globals/constants/queryWhiteKey'
import { cacheRequestWrap } from '@/utils/requestUtils'
import { delay } from '@/utils/utils'

const safeDispatch = (action: { type: string; payload?: unknown }): void => {
    const store = getStore()
    if (store && typeof store.dispatch === 'function') {
        store.dispatch(action)
    }
}

/**
 * 给 action.type 加上 namespace 前缀，方便在非 saga 场景直接 dispatch。
 */
const withNamespace = (namespace: string, action: { type: string; payload?: unknown }) => {
    return { ...action, type: `${namespace}/${action.type}` }
}

/**
 * 直接更新 menu 模块数据（内部使用 safeDispatch）。
 */
const dispatchMenuAction = (action: { type: string; payload?: unknown }) => {
    safeDispatch(withNamespace('menu', action))
}

/**
 * 规范化白名单数据（兼容字段反向逻辑）。
 * 入参为接口响应对象（含 data）。
 */
const buildUserMenuWhiteList = (response: { data?: Record<string, unknown> | null } | null | undefined) => {
    const data = response?.data
    return {
        ...(data || {}),
        AFTER_SALE_IPC_OPEN_V2: !(data?.AFTER_SALE_IPC_OPEN_V2 as boolean),
    }
}

/**
 * 生成大店 COID 列表更新 action。
 * 入参为接口响应对象（含 data）。
 */
const applyBigShopCoIdListUpdate = (response: { data?: unknown } | null | undefined) => {
    dispatchMenuAction({
        type: 'updateBigShopCoIdList',
        payload: response?.data,
    })
}

/**
 * 生成白名单更新 action。
 * 入参为接口响应对象（含 data）。
 */
const applyUserMenuWhiteListUpdate = (response: { data?: Record<string, unknown> | null } | null | undefined) => {
    const temp = buildUserMenuWhiteList(response)
    dispatchMenuAction({
        type: 'update',
        payload: {
            userMenuWhiteList: temp,
            userMenuWhiteListInited: true,
        },
    })
}

/**
 * 生成达人白名单更新 action。
 * 入参为接口响应对象（含 data）。
 */
const applyUserMenuWhiteListDarenUpdate = (response: { data?: Record<string, unknown> | null } | null | undefined) => {
    const temp = {
        ...(response?.data || {}),
    }
    dispatchMenuAction({
        type: 'update',
        payload: {
            userMenuWhiteList: temp,
            userMenuWhiteListInited: true,
        },
    })
}

/**
 * 生成用户菜单列表更新 action，同时做异常埋点。
 * 入参为接口响应对象（含 data/success/message）。
 */
const applyUserMenusUpdate = (
    response:
        | {
              data?: unknown
              success?: boolean
              message?: unknown
          }
        | null
        | undefined,
) => {
    const data = response?.data
    if (!Array.isArray(data)) {
        captureMessage('userMenus异常', {
            anchor: 'queryUserMenus',
            extra: {
                success: response?.success,
                message: response?.message,
                data: JSON.stringify(data),
                timestamp: Date.now(),
            },
        })
    }
    dispatchMenuAction({
        type: 'update',
        payload: {
            userMenus: data,
        },
    })
}

/**
 * 生成黑名单更新 action。
 * 入参为接口响应对象（含 data）。
 */
const applyBlackMenuListUpdate = (response: { data?: unknown } | null | undefined) => {
    dispatchMenuAction({
        type: 'saveBlackMenuList',
        payload: transBlackList(response?.data),
    })
}

/**
 * 生成菜单权限更新 action。
 * 入参为接口响应对象（含 data）。
 */
const applyMenuPermissionUpdate = (response: { data?: unknown } | null | undefined) => {
    dispatchMenuAction({
        type: 'update',
        payload: {
            menus: response?.data,
        },
    })
}

const transBlackList = data => {
    if (Array.isArray(data)) {
        return data.reduce((t, c) => {
            return t.concat(c.split(','))
        }, [])
    }

    return []
}

// 渠道及供应侧 菜单权限
export default {
    namespace: 'menu',
    state: {
        menus: [],
        userMenus: [],
        showMenuTip: [], // 需要动态控制菜单显示tip的menuKey
        shopIdList: {}, // 返回对象 {Alibaba: "11899158"}
        shopInfoTotal: [], // 可以选择的平台下店铺的数量
        platformBanKeywords: {}, // 平台禁用词
        // 菜单黑名单，本来是放在layout里面自己调用，由于支付也需要判断，所以放到全局
        blackMenuList: [],
        // 大店的coid 是个数组，但是目前只有一个
        bigShopCoIdList: [],
        updateBigShopCoIdListFetching: false, // 用于避免接口重复请求
        blackMenuListMounted: false,
        userMenuWhiteList: {
            GOODS_RULE_OPERATE_V2: false,
            DOU_YIN_SPU_MANAGE: false,
            EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST: false,
            SEARCH_STOCK_BLOCK: false, // 只看有货 黑名单
            ORDER_FREIGHT_CALC_RULE_SHOW: false,
            DRP_RULE_MERGE: false,
            FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_WXSTORE: false,
            FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_KDT: false,
            ERP_AFTERSALE_BIGSHOP_AUTO: false,
            NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST: false,
            PUSH_TO_SUPPLIER_AMOUNT_BY_AFTERSALE_TYPE_WHITELIST: false,
            AFTER_SALE_JD_AUTO_RETURN_REFUND_WHITE_LIST: false,
            DIS_DRP_SPLIT_REPUSH_RECALC_WHITELIST: false,
            DRP_FREE_HANDLING_FEE_WHITE_LIST: false,
            DRP_FREE_HANDLING_FEE_V2_WHITE_LIST: false,
            AFTERSALE_TWICE_EXCHANGE_ORDER_MULTI_PUSH: false,
            MULTI_LEVEL_DISTRIBUTION_REISSUE_NORMALIZE_AUTO_SYNC: false,
            MULTI_ADDRESS_UPGRADE_SWITCH_WHITELIST: false,
            SUP_GOODS_STRATEGY_FOR_RETURN_ADDRESS_WHITE_LIST: false,
            AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST: false,
            DRP_SEND_EXCHANGE_ALLOW_FUND_NEGATIVE: false,
            TIKTOK_PLATFORM_WHITE_LIST: false,
            AFTER_SALE_ADDRESS_MIDDLEMAN: false,
            DRP_SEND_UPLOAD_AFS_ADDRESS_PDD: false,
            DRP_EXPRESS_AGENCY_DELIVING_LIMIT_SYNC_STOCK: false,
            RULE_OPERATE_ERP_LABEL_WHITE_LIST: false,
            ORDER_ORIGINAL_SOID_WHITELIST: false,
            COMMISSION_SUPPORT_GOODS_SKU: false,
            COMMISSION_EXTEND_REFUND_TYPE: false,
            SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST: false,
            AFTER_RETURN_ADDRESS_EXCEPTION: false,
            AFTER_SALES_RETURN_ASYNC_WHITELIST: false,
            AFTERSALE_NEGOTIATION_ENABLE_WHITELIST: false,
            AFTER_SALE_ORDER_BEAR_FREIGHT_SELECTION_WHITELIST: false,
            PUSH_ORDER_COMMERCIALIZE_WHITELIST: false,
            FORECAST_PLATFORM_WHITE_LIST: false,
            SHOP_ITEM_UPDATE_DELIVERY_TIME: false,
            DY_ALLOW_MODIFY_CATEGORY: false,
            ORDER_SIMULATION_CALC_NEW: false,
            DISTRIBUTOR_AFTERSALE_ORDER_SUPPORTS_FILTER_RETURN_LOGISTICS_STATUS: false,
            AFTERSALE_EXPRESS_INTERCEPT_TPW_SUPPLY_DISTRIBUTION_WHITELIST: false,
            TMALL_BACTH_SHELVES_USE_PRODUCT_WHITELIST: false,
            UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST: false,
            ACCESS_PRE: true, // 默认给true， 如果false了再跳转吧
            DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE: false,
            SHOW_CURRENT_ARREARS_COIDS: false,
            PAY_REFUND_ONLINE_SUFFIX_WHITELIST: false,
            GOODS_DRAFT_STATUS: false,
            ORDER_EXCHANGE_GOODS_WHITE_LIST: false,
            GOODS_WECHAT_NOTIFY_COID: false,
            ASYNC_AUDIT_ORDER_WHITE_LIST: false,
            ORDER_DRP_ZPLAN_SETLC_REFREIGHT: false,
            INSIDER_COID_LIST: false,
            CHANNEL_CUSTOMER_CENTER_DIY_DATE: false,
            HOT_GOODS_PRIVILEGE: false,
            MULTI_LEVEL_DIS_SETTLEMENT_WHITE_LIST: false,
            FIND_DAREN_WHITELIST: false,
            PENDING_ORDERS_BY_SUPPLIER_COUNT: false,
            AFTER_SALE_IPC_OPEN_V2: false,
            AFTER_SALE_IPC_OPEN_MERGE: false,
            AS_SHIP_UPLOAD_RETURN_ADDRESS_WHITE_LIST: false,
            UNDERPRICED_ORDER_WHITELIST: false,
            GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST: false,
            SUPPLIER_AUTO_REFUND: false,
            DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST: false,
            AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST: false,
            BATCH_UPDATE_DIS_PRICE_WHITE_LIST: false,
            MIN_PURCHASE_COIDS: false,
            GOODS_RULE_OPERATE_SKU_REPLENISHMENT: false,
            DOUYIN_TIME_SALE_STOCK: false,
            PRINTER_CLOSE_PROMT_WHITE_LIST: false,
            PRINTER_CLOSE_WHITE_LIST: false,
            PRINTER_INOUT_LIST_5000_WHITELIST: false,
            AUTONOMY_SYNC_PLATFORM_CATE_WHITE: false,
            PARTNER_SPU_SHOP_LINK_WHITE_LIST: false,
            DRP_NOT_SYNC_ABNORMAL: false,
            TAO_GOODS_SHELVES_TAO_PLATFORM: false,
            CLEAR_PARTNER_SALE_MARK_WHITE_LIST: false,
            ORDER_TIMEOUT_COMPENSATION: false,
            PRINTER_MTSGYY_UPGRADE_WAYBILL_WHITELIST: false,
            DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST: false,
            ORDER_SPLIT_IGNORE_QUESTION: false,
            CAPTCHA_VALIDATE: false,
            AI_FILL_SPEC_VALUE_WHITE_LIST: false,
            DAREN_FIND_DAREN_KS_WHITE_LIST: false,
            DAREN_FIND_DAREN_SPH_WHITE_LIST: false,
        },
        appShelvesGuideWhiteList: [], // 抖音小程序上架引导
        userMenuWhiteListInited: false, // 白名单接口是否请求结束
    },
    effects: {
        *queryAppShelvesGuideWhiteList(_, { call, put }) {
            try {
                const response = yield call(queryAppShelvesGuideWhiteListUsingGET1)

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                appShelvesGuideWhiteList: data,
                            },
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                // 404 抛出 error 对象被外面的 try catch 拿到..
                console.error('REJECT_queryAppShelvesGuideWhiteList', error)
            }
        },
        *queryBigShopCoIdList(_, { call, put, select }) {
            // 检查是否已经获取过列表
            const updateBigShopCoIdListFetching = yield select(state => state.menu.updateBigShopCoIdListFetching)

            const currentBigShopCoIdList = yield select(state => state.menu.bigShopCoIdList)
            if (currentBigShopCoIdList?.length > 0) return currentBigShopCoIdList // 如果已经获取过，则直接返回当前列表数据

            if (updateBigShopCoIdListFetching) {
                // 如果正在获取列表，则等待
                yield delay(100) // 每 100ms 检查一次
                return yield put({ type: 'queryBigShopCoIdList' })
            }

            yield put({
                type: 'updateBigShopCoIdListFetching',
                payload: true,
            })
            try {
                // 发起请求获取大店 COID 列表

                const response = yield call(
                    cacheRequestWrap(getBigShopCoIdList, 'getBigShopCoIdList', {
                        onUpdate: result => {
                            applyBigShopCoIdListUpdate(result)
                        },
                    }),
                )
                if (response.success) {
                    // 请求成功，更新 state
                    applyBigShopCoIdListUpdate(response)
                    yield put({
                        type: 'updateBigShopCoIdListFetching',
                        payload: false,
                    })
                    return response.data
                } else {
                    $message.error(response.message)
                }
            } catch (error) {
                console.error('queryBigShopCoIdList error', error)
            }
        },

        *queryUserMenuWhiteList(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(
                    cacheRequestWrap(queryUserMenuWhiteList, 'queryUserMenuWhiteList', {
                        onUpdate: result => {
                            applyUserMenuWhiteListUpdate(result)
                        },
                    }),
                    {
                        keyList: [
                            DOU_YIN_SPU_MANAGE,
                            EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST,
                            SEARCH_STOCK_BLOCK,
                            DRP_RULE_MERGE,
                            FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_WXSTORE,
                            FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_KDT,
                            ERP_AFTERSALE_BIGSHOP_AUTO,
                            NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST,
                            PUSH_TO_SUPPLIER_AMOUNT_BY_AFTERSALE_TYPE_WHITELIST,
                            AFTER_SALE_JD_AUTO_RETURN_REFUND_WHITE_LIST,
                            DIS_DRP_SPLIT_REPUSH_RECALC_WHITELIST,
                            DRP_FREE_HANDLING_FEE_WHITE_LIST,
                            DRP_FREE_HANDLING_FEE_V2_WHITE_LIST,
                            AFTERSALE_TWICE_EXCHANGE_ORDER_MULTI_PUSH,
                            MULTI_LEVEL_DISTRIBUTION_REISSUE_NORMALIZE_AUTO_SYNC,
                            MULTI_ADDRESS_UPGRADE_SWITCH_WHITELIST,
                            AFTER_SALE_ORDER_BEAR_FREIGHT_SELECTION_WHITELIST,
                            SUP_GOODS_STRATEGY_FOR_RETURN_ADDRESS_WHITE_LIST,
                            DRP_SEND_EXCHANGE_ALLOW_FUND_NEGATIVE,
                            TIKTOK_PLATFORM_WHITE_LIST,
                            AFTER_SALE_ADDRESS_MIDDLEMAN,
                            DRP_SEND_UPLOAD_AFS_ADDRESS_PDD,
                            RULE_OPERATE_ERP_LABEL_WHITE_LIST,
                            ORDER_FREIGHT_CALC_RULE_SHOW,
                            SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST,
                            ORDER_EXCHANGE_GOODS_WHITE_LIST,
                            DRP_EXPRESS_AGENCY_DELIVING_LIMIT_SYNC_STOCK,
                            AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST,
                            AFTERSALE_NEGOTIATION_ENABLE_WHITELIST,
                            AFTER_SALES_RETURN_ASYNC_WHITELIST,
                            CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST,
                            GOODS_RULE_OPERATE_V2,
                            ACCESS_PRE,
                            DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE,
                            ORDER_DRP_ZPLAN_SETLC_REFREIGHT,
                            SHOW_CURRENT_ARREARS_COIDS,
                            GOODS_DRAFT_STATUS,
                            GOODS_WECHAT_NOTIFY_COID,
                            ASYNC_AUDIT_ORDER_WHITE_LIST,
                            ORDER_SIMULATION_CALC_NEW,
                            DISTRIBUTOR_AFTERSALE_ORDER_SUPPORTS_FILTER_RETURN_LOGISTICS_STATUS,
                            AFTERSALE_EXPRESS_INTERCEPT_TPW_SUPPLY_DISTRIBUTION_WHITELIST,
                            AFTER_SALE_IPC_OPEN_V2,
                            AFTER_SALE_IPC_OPEN_MERGE,
                            AS_SHIP_UPLOAD_RETURN_ADDRESS_WHITE_LIST,
                            INSIDER_COID_LIST,
                            HOT_GOODS_PRIVILEGE,
                            MULTI_LEVEL_DIS_SETTLEMENT_WHITE_LIST,
                            ORDER_GUIDE_WHITELIST_MASTER_SLAVE,
                            PUSH_ORDER_COMMERCIALIZE_WHITELIST,
                            FIND_DAREN_WHITELIST,
                            PRINTER_CLOSE_WHITE_LIST,
                            PRINTER_CLOSE_PROMT_WHITE_LIST,
                            FORECAST_PLATFORM_WHITE_LIST,
                            SHOP_ITEM_UPDATE_DELIVERY_TIME,
                            DY_ALLOW_MODIFY_CATEGORY,
                            TMALL_BACTH_SHELVES_USE_PRODUCT_WHITELIST,
                            UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST,
                            PURCHASE_AMOUNT_SHARDING_WHITELIST,
                            ORDER_ORIGINAL_SOID_WHITELIST,
                            COMMISSION_SUPPORT_GOODS_SKU,
                            COMMISSION_EXTEND_REFUND_TYPE,
                            PENDING_ORDERS_BY_SUPPLIER_COUNT,
                            PAY_REFUND_ONLINE_SUFFIX_WHITELIST,
                            CHANNEL_CUSTOMER_CENTER_DIY_DATE,
                            UNDERPRICED_ORDER_WHITELIST,
                            GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST,
                            SUPPLIER_AUTO_REFUND,
                            DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST,
                            AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST,
                            FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST,
                            BATCH_UPDATE_DIS_PRICE_WHITE_LIST,
                            MIN_PURCHASE_COIDS,
                            GOODS_RULE_OPERATE_SKU_REPLENISHMENT,
                            DOUYIN_TIME_SALE_STOCK,
                            PRINTER_INOUT_LIST_5000_WHITELIST,
                            AUTONOMY_SYNC_PLATFORM_CATE_WHITE,
                            PARTNER_SPU_SHOP_LINK_WHITE_LIST,
                            DRP_NOT_SYNC_ABNORMAL,
                            TAO_GOODS_SHELVES_TAO_PLATFORM,
                            CLEAR_PARTNER_SALE_MARK_WHITE_LIST,
                            ORDER_TIMEOUT_COMPENSATION,
                            PRINTER_MTSGYY_UPGRADE_WAYBILL_WHITELIST,
                            DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST,
                            ORDER_SPLIT_IGNORE_QUESTION,
                            CAPTCHA_VALIDATE,
                            AI_FILL_SPEC_VALUE_WHITE_LIST,
                            DAREN_FIND_DAREN_KS_WHITE_LIST,
                            DAREN_FIND_DAREN_SPH_WHITE_LIST,
                        ],
                    },
                )

                const { success, message } = response || {}
                if (success) {
                    applyUserMenuWhiteListUpdate(response)
                } else {
                    $message.error(message)
                }
            } catch (error) {
                console.error('REJECT_queryUserMenuWhiteList 获取白名单失败', error)
            }
        },
        *checkPreRedirect(_, { select }) {
            const currentUser = yield select(state => state.user?.currentUser)
            const accessPre = yield select(state => state.menu?.userMenuWhiteList?.ACCESS_PRE)
            if (
                accessPre === false &&
                !currentUser?.isAgent &&
                window.PROJECT_CONFIG?.sentryMode === 'pre' &&
                window.top === window.self
            ) {
                window.location.href = window.location.href.replace('pre', '')
            }
        },
        *queryUserMenuWhiteListDaren(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(
                    cacheRequestWrap(queryUserMenuWhiteList, 'queryUserMenuWhiteListDaren', {
                        onUpdate: result => {
                            applyUserMenuWhiteListDarenUpdate(result)
                        },
                    }),
                    {
                        keyList: [
                            DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST,
                            FIND_DAREN_WHITELIST,
                            ERP_AFTERSALE_BIGSHOP_AUTO,
                            UNDERPRICED_ORDER_WHITELIST,
                            DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST,
                            DAREN_FIND_DAREN_KS_WHITE_LIST,
                            DAREN_FIND_DAREN_SPH_WHITE_LIST,
                        ],
                    },
                )

                const { success, message } = response || {}
                if (success) {
                    applyUserMenuWhiteListDarenUpdate(response)
                } else {
                    $message.error(message)
                }
            } catch (error) {
                console.error('REJECT_queryUserMenuWhiteListDaren 获取白名单失败', error)
            }
        },
        *queryUserMenus(_, { call, put }) {
            let contractList = null

            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const {
                    success: versionSuccess,
                    data: versionData,
                    message: versionMessage,
                } = yield call(getContractVersion)
                if (versionSuccess) {
                    contractList = versionData?.contractList
                } else {
                    $message.error(versionMessage)
                }
            } catch (error) {
                console.error('REJECT_getContractVersion 获取用户版本失败', error)
            }
            const response = yield call(
                cacheRequestWrap(getUserMenus, 'getUserMenus', {
                    onUpdate: result => {
                        applyUserMenusUpdate(result)
                    },
                }),
                {
                    envType: PROJECT_CONFIG.sentryMode,
                    appCode: fullAppCode,
                    showArea: ['MENU_CATALOGUE'],
                    contractList,
                },
            )

            const { success, message } = response || {}
            if (success) {
                applyUserMenusUpdate(response)
            } else {
                $message.error(message)
            }
        },
        *fetchBlackMenuList(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const headers = isZongHengApp
                    ? {
                          domain: document.domain,
                      }
                    : {}

                const response = yield call(
                    cacheRequestWrap(queryHidedMenuList, `queryHidedMenuList_isZongHengApp_${isZongHengApp}`, {
                        onUpdate: result => {
                            applyBlackMenuListUpdate(result)
                        },
                    }),
                    null,
                    headers,
                )
                const { success, message } = response || {}
                if (success) {
                    applyBlackMenuListUpdate(response)
                    return
                } else {
                    $message.error(message)
                    return null
                }
            } catch (e) {
                console.error('REJECT_获取菜单黑名单失败', e)
            }
        },
        *queryBindShop(_, { call, put }) {
            const params = {
                shopTypes: PLATFORM_INFO_LIST,
            }
            try {
                const response = yield call(queryBindShopApi, { ...params })

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                shopIdList: data,
                            },
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                console.error('REJECT_根据店铺类型获取店铺信息失败', error)
            }
        },
        *queryBindShopTotal({ payload }, { call, put }) {
            const includeShopSites = filterShopTypeListByPlatformType(PLATFORM_INFO_LIST)
            const params = {
                includeShopSites,
                sync: payload?.sync || false,
            }
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(queryShopInfoTotal, { ...params })

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                shopInfoTotal: data,
                            },
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                // 404 抛出 error 对象被外面的 try catch 拿到..
                console.error('REJECT_获取站点下店铺统计信息失败', error)
            }
        },
        *queryPlatformBanKeywords(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(queryPlatformBanKeywords, {})

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                platformBanKeywords: (data || []).reduce((result, item) => {
                                    if (item.enable) {
                                        result[item.shopType] = {
                                            ...item,
                                            needCheckFiled: (item.needCheckFiled || []).reduce((result2, item2) => {
                                                result2[item2.filedType] = item2.banKeywords
                                                return result2
                                            }, {}),
                                        }
                                    }
                                    return result
                                }, {}),
                            },
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                console.error('REJECT_getContractVersion 获取平台禁用的关键词失败', error)
            }
        },
        *query(_, { call, put }) {
            try {
                const response = yield call(
                    cacheRequestWrap(getUserMenuPermission, 'getUserMenuPermission', {
                        onUpdate: result => {
                            applyMenuPermissionUpdate(result)
                        },
                    }),
                )
                if (response) {
                    let { success, message, data } = response

                    if (success) {
                        applyMenuPermissionUpdate(response)

                        return data
                    } else {
                        $message.error(message)
                        return []
                    }
                }
            } catch (error) {
                if (
                    !window.TERMINANAME_IS_SQMALL ||
                    !window.TERMINANAME_IS_DLZ ||
                    PROJECT_CONFIG.terminalName !== 'TOWER'
                ) {
                    console.error('REJECT_getUserMenuPermission 网络错误', error)

                    const reback = encodeURIComponent(window.location.href)
                    history.push(`/error?reback=${reback}`)
                }
            }
        },
        *updateShowMenuTip({ payload }, { put }) {
            yield put({
                type: 'update',
                payload: {
                    showMenuTip: payload,
                },
            })
        },
    },
    reducers: {
        updateBigShopCoIdList(state, { payload }) {
            return {
                ...state,
                bigShopCoIdList: payload,
            }
        },
        updateBigShopCoIdListFetching(state, { payload }) {
            return {
                ...state,
                updateBigShopCoIdListFetching: payload,
            }
        },
        saveBlackMenuList(state, { payload }) {
            return {
                ...state,
                blackMenuListMounted: true,
                blackMenuList: payload,
            }
        },
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}
